import React from 'react'

function Footer() {
    return (
        <footer className="footer">
            <a href="https://www.yazigi.com.br/" target="_blank" className="link-footer">yazigi.com.br</a>
        </footer>
    )
}

export default Footer
